import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { SABISTranslateConfig } from 'sabis-components2';
import { CareersRouteReuseStrategy } from './routing/careers-route-reuse-strategy';
import { RouteCachingService } from '../@theme/shared/services/route-caching.service';

export function provideCoreConfig(): EnvironmentProviders {
    return makeEnvironmentProviders([
        CookieService,
        provideTranslateService(SABISTranslateConfig),
        {
            provide: RouteReuseStrategy,
            useClass: CareersRouteReuseStrategy,
            deps: [RouteCachingService]
        },
    ]);
}